export const UNLOCK_SCREEN_ELEMENT_ID = 'lender-unlock-screen';
export const UNLOCK_SCREEN_STYLE_ID = 'lender-unlock-screen-style';

// Co-brand fallback (DEV-3717): the tenant's splash color is inlined at build time as
// window.lsBrandSplashColor; this is used when a build carries no tenant brand (default
// Lender experience). The logo fallback lives in utils/brandLogo, shared with the splash screens.
export const FALLBACK_BACKGROUND_COLOR = '#2d323d';

export const UNLOCK_SCREEN_TITLE = 'Welcome back';
export const UNLOCK_SCREEN_SUBTITLE = 'Unlocking your workspace';

export const POWERED_BY_PREFIX = 'Powered by';
export const POWERED_BY_BRAND = 'Lender';
